import React, { Component } from 'react';

class Page404 extends Component {
  render() {
    return (
      <div>
        Errore 404
      </div>
    );
  }
}

export default Page404;